import { type PropsWithChildren } from 'react';
import {
  BackButton,
  NextButton,
  ScreenFields,
  useFormNav,
} from '@updater/ui-informant';
import { Box, Flex, H1, Text } from '@updater/ui-uds';

export interface AuthStackedTemplateProps {
  footerPanel?: React.ReactNode;
  backButton?: React.ReactNode;
  nextButton?: React.ReactNode;
}

export const AuthStackedTemplate: React.FC<
  PropsWithChildren<AuthStackedTemplateProps>
> = ({ footerPanel, backButton, nextButton }) => {
  const { currentScreenConfig } = useFormNav();

  const showBackButton = !currentScreenConfig?.hideBackButton;

  return (
    <Flex flexDirection="column" width="100%">
      {showBackButton && <Box mb="m">{backButton || <BackButton />}</Box>}
      <Box mb="m">
        {currentScreenConfig?.heading && (
          <H1 as="h1" variant={['xxl', 'xxl', 'xxxl', 'xxxl']}>
            {currentScreenConfig.heading}
          </H1>
        )}
        {currentScreenConfig?.subHeading && (
          <Box mt="xs">
            <Text variant="m" style={{ whiteSpace: 'pre-line' }}>
              {currentScreenConfig.subHeading}
            </Text>
          </Box>
        )}
      </Box>
      <Box mb="xl">
        <ScreenFields />
      </Box>
      <Box mb="xl">{nextButton || <NextButton />}</Box>
      {footerPanel ? <Box mb="xl">{footerPanel}</Box> : null}
    </Flex>
  );
};
